export function sendMessageWhenIdle(agent, text) {
  function sendWhenIdle() {
    var _agent$isAgentBusy;
    if (!(agent !== null && agent !== void 0 && (_agent$isAgentBusy = agent.isAgentBusy) !== null && _agent$isAgentBusy !== void 0 && _agent$isAgentBusy.call(agent))) {
      var _agent$sendMessage;
      agent === null || agent === void 0 || (_agent$sendMessage = agent.sendMessage) === null || _agent$sendMessage === void 0 || _agent$sendMessage.call(agent, text, {
        silent: true
      });
    } else {
      agent.addEventListener('mindset:agent-idle', function () {
        return sendWhenIdle();
      }, {
        once: true
      });
    }
  }
  sendWhenIdle();
}
export default sendMessageWhenIdle;